/* eslint-disable no-restricted-globals */
let appConfig;
const host = location.host;

if (
  host.includes("intapi") ||
  host.includes("10.1.18.12") ||
  host.includes("localhost")
) {
  console.log("INTEGRATION");
  appConfig = require("../configs/integration/config.json");
} else {
  console.log("STAGING OR PRODUCTION");
  appConfig = {
    apiProtocol: location.protocol,
    apiAddress: location.hostname,
    apiPort: "443",
    apiSegment: "/api",
    buildNumber: "3.3.0",
    recaptchaKey: "6LcP4zAUAAAAAGR0uWL2Z9XUhd0jyJsE1E4xaYmz",
    oAuth2: {
      server: "http://localhost/",
    },
  };
}

const config = {
  ...appConfig,
};

export default config;
